import request from "api/axiosClient";

export const getGraphicalNguoiDungMoi = async (values) => {
    const result = await request({
        url: "new-customer-report/graphical-statistics",
        method: "POST",
        data: values
    });
    return result?.data;
}
export const getDataNguoiDungMoi = async (values) => {
    const result = await request({
        url: "new-customer-report/data-statistics",
        method: "POST",
        data: values
    });
    return result?.data;
}